<!-- 申請詳細→修正から開く編集画面（24.7.24現在 新規作成はここからは行わない） -->
<template>
  <div class="dakoku-syuusei">
    <h3>打刻修正</h3>
    <template v-if="dakokuSyuusei">
      <div class="item">
        <b class="title">打刻日</b>
        <span>{{ dateFormat(dakokuSyuusei.dakoku_date) }}</span>
      </div>

      <div class="item">
        <koyouKeiyakuTimeSelect v-if="isInit" :isRequiredSyuugyouBasyo=false :isRequiredWorkTime=false
          :disableSyuugyouBasyo=true :koyouKeiyakuId="koyouKeiyakuId" :targetDate="dakokuSyuusei.dakoku_date"
          :workTimeId="dakokuSyuusei.koyou_keiyaku_time_id" @change="changeKoyouKeiyakuTime">
        </koyouKeiyakuTimeSelect>
      </div>

      <div class="item">
        <b class="title">出勤</b>
        <div class="before-after">
          <p class="before">{{ dakokuSyuusei.before_syukkin_datetime ? dakokuSyuusei.before_syukkin_datetime :
            '記録なし' }}</p>
          <p class="arrow">→</p>
          <time-picker class="after" v-model="dakokuSyuusei.syukkin_datetime"
            :error="getError(dakokuSyuusei, 'syukkin_datetime')" :disabled="isTorikeshi"></time-picker>
        </div>
      </div>

      <div class="item">
        <b class="title">退勤</b>
        <div class="before-after">
          <p class="before">{{ dakokuSyuusei.before_taikin_datetime ? dakokuSyuusei.before_taikin_datetime :
            '記録なし' }}</p>
          <p class="arrow">→</p>
          <time-picker class="after" v-model="dakokuSyuusei.taikin_datetime"
            :error="getError(dakokuSyuusei, 'taikin_datetime')" :disabled="isTorikeshi"></time-picker>
        </div>
      </div>

      <div class="item">
        <b class="title">外出</b>
        <div class="before-after">
          <p class="before">{{ dakokuSyuusei.before_gaisyutsu_datetime ? dakokuSyuusei.before_gaisyutsu_datetime
            : '記録なし' }}</p>
          <p class="arrow">→</p>
          <time-picker class="after" v-model="dakokuSyuusei.gaisyutsu_datetime"
            :error="getError(dakokuSyuusei, 'gaisyutsu_datetime')" :disabled="isTorikeshi"></time-picker>
        </div>
      </div>

      <div class="item">
        <b class="title">戻り</b>
        <div class="before-after">
          <p class="before">{{ dakokuSyuusei.before_modori_datetime ? dakokuSyuusei.before_modori_datetime :
            '記録なし' }}</p>
          <p class="arrow">→</p>
          <time-picker class="after" v-model="dakokuSyuusei.modori_datetime"
            :error="getError(dakokuSyuusei, 'modori_datetime')" :disabled="isTorikeshi"></time-picker>
        </div>
      </div>

      <div class="item">
        <b class="title">休憩</b>
        <div class="before-after">
          <p class="before">{{ dakokuSyuusei.before_kyuukei_times ? dakokuSyuusei.before_kyuukei_times :
            '記録なし' }}</p>
          <p class="arrow">→</p>
          <time-picker class="after" v-model="dakokuSyuusei.kyuukei_times" :startTime="{ hours: 0, minutes: 0 }"
            :minTime="{ hours: 0, minutes: 0, seconds: 0 }" :maxTime="{ hours: 2, minutes: 0, seconds: 0 }"
            :error="getError(dakokuSyuusei, 'kyuukei_times')" :disabled="isTorikeshi">
          </time-picker>
        </div>
      </div>
      <div class="item">
        <b class="title">打刻取消</b>
        <label><input type="checkbox" v-model="dakokuSyuusei.is_torikeshi" />打刻を取り消す</label>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, toRefs, ref, Ref, onMounted, nextTick } from 'vue';
import { dateFormat, timeFormat } from "@/filters/common";
import { useForm } from '@/composable/form/form';
import { Shinsei, ShinseiKoyouKeiyakuTime } from "@/types/Shinsei";
import KoyouKeiyakuTImeSelect from "@/components/shinsei/create/parts/KoyouKeiyakuTimeSelect.vue"
import { KoyouKeiyakuTimeSelectEmitData, SyuugyouBasyoAndKoyouKeiyakuOption } from '@/types/SyuugyouBasyo';
import { Logger } from '@/utils/Logger';

export default defineComponent({
  props: {
    form: {
      type: Object as () => Shinsei,
      default: null
    },
    selectSyuugyouBasyo: {
      type: Object as () => SyuugyouBasyoAndKoyouKeiyakuOption,
      default: null
    },
  },
  emits: {
    changeKoyouKeiyakuTime: (selectedSyuugyouBasyo: SyuugyouBasyoAndKoyouKeiyakuOption | null, selectedKoyouKeiyakuTimeOption: ShinseiKoyouKeiyakuTime | null) => true,
  },
  setup(props, context) {
    const { form } = toRefs(props);
    const { getError } = useForm();

    // 編集中の就業場所（雇用契約）と就業時間
    const workTimeId: Ref<number | null> = ref(null)
    const koyouKeiyakuId: Ref<number | null> = ref(null)

    const isInit = ref(false)

    onMounted(async () => {
      Logger.debug('----------------------------\n打刻修正申請コンポーネントの初期化開始')
      Logger.debug('打刻修正申請 onMounted', { '申請': form.value })
      nextTick(() => {
        Logger.debug('打刻修正申請 onMounted->nextTick', { '申請': form.value })
        if (!form.value.dakoku_syuusei) {
          Logger.debug('新規作成モードの初期化を行います')
          // ただし通常、新規作成はタイムシート画面のダイアログより下記テンプレートを使うためここでは行わない
          // src/resources/ts/components/dakoku/DakokuSyuusei.vue
          form.value.dakoku_syuusei = {
            dakoku_id: null,
            dakoku_date: null,
            gaisyutsu_datetime: null,
            kyuukei_times: null,
            modori_datetime: null,
            syukkin_datetime: null,
            taikin_datetime: null,
            is_torikeshi: false,
            before_gaisyutsu_datetime: null,
            before_kyuukei_times: null,
            before_modori_datetime: null,
            before_syukkin_datetime: null,
            before_taikin_datetime: null,
            koyou_keiyaku_time_id: null
          }
        } else {
          Logger.debug('編集モードの初期化を行います')
          workTimeId.value = form.value.shinsei_koyou_keiyaku_time.length > 0 ? form.value.shinsei_koyou_keiyaku_time[0].koyou_keiyaku_time_id : null
          koyouKeiyakuId.value = form.value.koyou_keiyaku_id ?? null
          Logger.debug('打刻修正申請より就業場所（雇用契約）と就業時間を初期化しました', { '雇用契約ID': koyouKeiyakuId.value, '就業時間ID': workTimeId.value })
        }
        isInit.value = true
        Logger.debug('打刻修正申請コンポーネントの初期化完了\n----------------------------')
      })
    })


    const isTorikeshi = computed(() => {
      return form.value.is_torikeshi
    })

    const timeFormatter = (time: string): string => {
      if (!form.value.dakoku_syuusei) return ''
      return timeFormat(form.value.dakoku_syuusei.dakoku_date + ' ' + time)
    }

    const changeKoyouKeiyakuTime = (emitData: KoyouKeiyakuTimeSelectEmitData) => {
      if (!form.value.dakoku_syuusei) return

      let koyouKeiyakuTime: ShinseiKoyouKeiyakuTime | null = null
      if (emitData.targetDate && emitData.selectedKoyouKeiyakuTimeOption) {
        form.value.dakoku_syuusei.koyou_keiyaku_time_id = emitData.selectedKoyouKeiyakuTimeOption.val
        koyouKeiyakuTime = {
          shinsei_id: form.value.shinsei_id,
          koyou_keiyaku_time_id: emitData.selectedKoyouKeiyakuTimeOption.val,
          target_date: emitData.targetDate,
          tsuujouTime: null,
          isHannichi: null,
          canOnlyAmKinmu: null,
          canOnlyPmKinmu: null,
        }
      } else {
        form.value.dakoku_syuusei.koyou_keiyaku_time_id = null
        form.value.shinsei_koyou_keiyaku_time = []
      }

      // 就業場所に関する情報をemitする（申請オブジェクトの変更等は親に移譲する）
      context.emit('changeKoyouKeiyakuTime', emitData.selectedSyuugyouBasyo, koyouKeiyakuTime);
    }

    return {
      dakokuSyuusei: form.value.dakoku_syuusei,
      dateFormat,
      timeFormat,
      getError,
      timeFormatter,
      isTorikeshi,
      changeKoyouKeiyakuTime,
      workTimeId,
      koyouKeiyakuId,
      isInit
    }
  },
  components: {
    'koyouKeiyakuTimeSelect': KoyouKeiyakuTImeSelect
  },
})
</script>

<style lang="scss" scoped>
@import '@scss/components/shinsei-create.scss';
</style>
